import { seedProgressForStage } from "./dev-stage-data";
import { seedsAllowed } from "./seed-gate";
import type { StartProgress } from "../progress/start-progress";
type StartPreview = {
  readonly progress: StartProgress;
  readonly demo: {
    readonly from: number;
  } | null;
  readonly fail: DevFail | null;
};
export function startPreview({
  search,
  nodeEnv,
  flagsOn,
}: {
  readonly search: URLSearchParams;
  readonly nodeEnv: string | undefined;
  readonly flagsOn: string | undefined;
}): StartPreview | null {
  if (!seedsAllowed({ nodeEnv, flagsOn })) return null;

  const stage = parseDevStage(search.getAll("stage"));
  const demo = parseDemo({
    rawDemo: search.getAll("demo"),
    rawFrom: search.getAll("from"),
  });
  const fail = parseDevFail(search.getAll("fail"));

  if (stage === null && demo === null && fail === null) return null;

  let progress = seedProgressForStage(
    stage ?? demo?.from ?? (fail ? stageForDevFail(fail) : 0),
  );

  if (fail === "request" && progress.experienceRequest) {
    progress = {
      ...progress,
      experienceRequest: { ...progress.experienceRequest, status: "failed" },
    };
  }

  if (fail === "submission" && progress.leagueSubmission) {
    progress = {
      ...progress,
      leagueSubmission: { ...progress.leagueSubmission, status: "rejected" },
    };
  }

  return { progress, demo, fail };
}
function parseDevStage(raw: readonly string[]): number | null {
  const value = raw.at(0);
  return value !== undefined && /^[0-7]$/.test(value) ? Number(value) : null;
}
function parseDemo({
  rawDemo,
  rawFrom,
}: {
  readonly rawDemo: readonly string[];
  readonly rawFrom: readonly string[];
}): {
  readonly from: number;
} | null {
  const demo = rawDemo.at(0);

  if (demo !== "1") return null;

  const from = rawFrom.at(0);
  return {
    from: from !== undefined && /^[0-7]$/.test(from) ? Number(from) : 0,
  };
}
type DevFail = "poll" | "auth" | "player" | "request" | "submission";
function parseDevFail(raw: readonly string[]): DevFail | null {
  const value = raw.at(0);
  return value === "poll" ||
    value === "auth" ||
    value === "player" ||
    value === "request" ||
    value === "submission"
    ? value
    : null;
}
function stageForDevFail(fail: DevFail): number {
  switch (fail) {
    case "auth":
      return 0;
    case "player":
      return 1;
    case "poll":
      return 3;
    case "request":
      return 5;
    case "submission":
      return 6;
  }
}
